import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    ScatterController,
    BubbleController,
    TimeScale,
    TimeSeriesScale,
    Filler,
} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import { Chart } from 'react-chartjs-2';
import { Box, SxProps } from '@mui/material';
import { CircularProgress } from '@mui/material';
import 'chartjs-adapter-luxon';

interface ChartSupplyProps {
    data?: any,
    options?: any,
    loading: boolean,
    monitorId?: number,
}

ChartJS.register(
    annotationPlugin,
    LinearScale,
    Filler,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    ScatterController,
    BubbleController,
    BarController,
    TimeScale,
    TimeSeriesScale
);

export const ChartSupply = (props: ChartSupplyProps): JSX.Element => {
    const {
        data,
        options,
        loading = true
    } = props;

    const render = () => {
        if (loading) {
            return (
                <CircularProgress
                    color="success"
                />
            )
        }

        return (
            <Chart
                type='line'
                data={data}
                options={options}
            >
            </Chart>
        )
    }

    const rootStyle: SxProps = {
        flexGrow: 1,
        position: 'relative',
        margin: 'auto',
    }

    return (
        <Box
            sx={rootStyle}
        >
            {
                render()
            }        
        </Box>
    )
}